import { SelfieVerificationStep } from './types';

export const FACETEC_STRINGS = [
  'FaceTec_accessibility_cancel_button',
  'FaceTec_feedback_center_face',
  'FaceTec_feedback_face_not_found',
  'FaceTec_feedback_move_phone_away',
  'FaceTec_feedback_move_away_web',
  'FaceTec_feedback_move_phone_closer',
  'FaceTec_feedback_move_phone_to_eye_level',
  'FaceTec_feedback_move_to_eye_level_web',
  'FaceTec_feedback_face_not_looking_straight_ahead',
  'FaceTec_feedback_face_not_upright',
  'FaceTec_feedback_face_not_upright_mobile',
  'FaceTec_feedback_hold_steady',
  'FaceTec_feedback_move_web_closer',
  'FaceTec_feedback_move_web_even_closer',
  'FaceTec_feedback_use_even_lighting',
  'FaceTec_instructions_header_ready_desktop',
  'FaceTec_instructions_header_ready_1_mobile',
  'FaceTec_instructions_header_ready_2_mobile',
  'FaceTec_instructions_message_ready_desktop',
  'FaceTec_instructions_message_ready_1_mobile',
  'FaceTec_instructions_message_ready_2_mobile',
  'FaceTec_action_im_ready',
  'FaceTec_presession_frame_your_face',
  'FaceTec_presession_look_straight_ahead',
  'FaceTec_presession_hold_steady3',
  'FaceTec_presession_hold_steady2',
  'FaceTec_presession_hold_steady1',
  'FaceTec_presession_eyes_straight_ahead',
  'FaceTec_presession_remove_dark_glasses',
  'FaceTec_presession_neutral_expression',
  'FaceTec_presession_conditions_too_bright',
  'FaceTec_presession_brighten_your_environment',
  'FaceTec_result_facescan_upload_message',
  'FaceTec_retry_header',
  'FaceTec_retry_subheader_message',
  'FaceTec_retry_your_image_label',
  'FaceTec_retry_ideal_image_label',
  'FaceTec_retry_instruction_message_1',
  'FaceTec_retry_instruction_message_2',
  'FaceTec_retry_instruction_message_3',
  'FaceTec_action_try_again',
  'FaceTec_camera_feed_issue_header',
  'FaceTec_camera_feed_issue_subheader_message',
  'FaceTec_camera_feed_issue_table_header_1',
  'FaceTec_camera_feed_issue_table_header_2',
  'FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error',
  'FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error',
  'FaceTec_camera_feed_issue_table_row_1_cell_1',
  'FaceTec_camera_feed_issue_table_row_1_cell_2',
  'FaceTec_camera_feed_issue_table_row_2_cell_1',
  'FaceTec_camera_feed_issue_table_row_2_cell_2',
  'FaceTec_camera_feed_issue_table_row_3_cell_1',
  'FaceTec_camera_feed_issue_table_row_3_cell_2',
  'FaceTec_camera_feed_issue_action',
  'FaceTec_camera_feed_issue_action_firefox_permissions_error',
  'FaceTec_action_ok',
  'FaceTec_action_continue',
  'FaceTec_action_confirm',
  'FaceTec_initializing_camera',
  'FaceTec_initializing_camera_still_loading',
  'FaceTec_action_accept_photo',
  'FaceTec_action_retake_photo',
  'FaceTec_result_success_message',
  'FaceTec_idscan_type_selection_header',
  'FaceTec_idscan_capture_id_front_instruction_message',
  'FaceTec_idscan_capture_id_back_instruction_message',
  'FaceTec_idscan_review_id_front_instruction_message',
  'FaceTec_idscan_review_id_back_instruction_message',
  'FaceTec_idscan_additional_review_message',
  'FaceTec_result_idscan_upload_message',
  'FaceTec_result_idscan_unsuccess_message',
  'FaceTec_result_idscan_success_front_side_message',
  'FaceTec_result_idscan_success_front_side_back_next_message',
  'FaceTec_result_idscan_success_back_side_message',
  'FaceTec_result_idscan_success_passport_message',
  'FaceTec_result_idscan_success_user_confirmation_message',
  'FaceTec_result_idscan_success_additional_review_message',
  'FaceTec_result_idscan_retry_face_did_not_match_message',
  'FaceTec_result_idscan_retry_id_not_fully_visible_message',
  'FaceTec_result_idscan_retry_ocr_results_not_good_enough_message',
  'FaceTec_result_idscan_retry_id_type_not_suppported_message',
  'FaceTec_result_idscan_retry_barcode_not_read_message',
];

export const FACETEC_STRINGS_NOT_USED = [
  'FaceTec_accessibility_tap_guidance',
  'FaceTec_accessibility_key_down_guidance',
  'FaceTec_accessibility_feedback_move_phone_away',
  'FaceTec_accessibility_feedback_move_phone_closer',
  'FaceTec_accessibility_feedback_face_too_far_left',
  'FaceTec_accessibility_feedback_face_too_far_right',
  'FaceTec_accessibility_feedback_face_too_low',
  'FaceTec_accessibility_feedback_face_too_high',
  'FaceTec_accessibility_feedback_face_rotated_too_far_left',
  'FaceTec_accessibility_feedback_face_rotated_too_far_right',
  'FaceTec_accessibility_feedback_face_looking_too_far_left',
  'FaceTec_accessibility_feedback_face_looking_too_far_right',
  'FaceTec_accessibility_feedback_face_not_in_camera',
  'FaceTec_accessibility_feedback_hold_phone_to_eye_level',
  'FaceTec_accessibility_feedback_move_away_web',
  'FaceTec_accessibility_feedback_move_closer_web',
  'FaceTec_accessibility_feedback_hold_to_eye_level_web',
  'FaceTec_camera_feed_issue_header_mobile',
  'FaceTec_camera_feed_issue_subheader_message_mobile',
  'FaceTec_camera_feed_issue_subtable_message',
  'FaceTec_camera_permission_header',
  'FaceTec_camera_permission_message',
  'FaceTec_enter_fullscreen_header',
  'FaceTec_enter_fullscreen_message',
  'FaceTec_enter_fullscreen_action',
  'FaceTec_idscan_ocr_confirmation_main_header',
  'FaceTec_idscan_ocr_confirmation_scroll_message',
];

export const FACETEC_STRING_MAPPING = {
  FaceTec_instructions_header_ready_1_mobile: 'FaceTec_instructions_header_ready_desktop',
  FaceTec_instructions_header_ready_2_mobile: 'FaceTec_instructions_header_ready_desktop',
  FaceTec_instructions_message_ready_1_mobile: 'FaceTec_instructions_message_ready_desktop',
  FaceTec_instructions_message_ready_2_mobile: 'FaceTec_instructions_message_ready_desktop',
  FaceTec_feedback_move_away_web: 'FaceTec_feedback_move_phone_away',
  FaceTec_initializing_camera_still_loading: 'FaceTec_initializing_camera',
  FaceTec_presession_hold_steady3: 'FaceTec_presession_hold_steady',
  FaceTec_presession_hold_steady2: 'FaceTec_presession_hold_steady',
  FaceTec_presession_hold_steady1: 'FaceTec_presession_hold_steady',
  FaceTec_presession_frame_your_face: 'FaceTec_feedback_face_not_found',
  FaceTec_presession_eyes_straight_ahead: 'FaceTec_feedback_face_not_looking_straight_ahead',
  FaceTec_presession_look_straight_ahead: 'FaceTec_feedback_face_not_looking_straight_ahead',
  FaceTec_retry_instruction_message_2: 'FaceTec_presession_neutral_expression',
  FaceTec_action_retake_photo: 'SelfieVerify.retake',
  FaceTec_action_take_photo: 'AgeVerification.takePhoto',
  FaceTec_action_accept_photo: 'VideoChat.accept',
  FaceTec_result_success_message: 'success',
  FaceTec_accessibility_cancel_button: 'cancel',
  FaceTec_action_try_again: 'tryAgain',
  FaceTec_camera_feed_issue_action_firefox_permissions_error: 'ok',
  FaceTec_action_ok: 'ok',
  FaceTec_action_continue: 'continue',
  FaceTec_action_confirm: 'confirm',
  FaceTec_idscan_review_id_back_instruction_message: 'UserVerification.id.isPhotoClearAndLegible',
  FaceTec_idscan_review_id_front_instruction_message: 'UserVerification.id.isPhotoClearAndLegible',
  FaceTec_result_idscan_success_front_side_message: 'UserVerification.id.scanComplete',
  FaceTec_result_idscan_success_back_side_message: 'UserVerification.id.scanComplete',
  FaceTec_result_idscan_success_user_confirmation_message: 'UserVerification.id.scanComplete',
};
export const FACETEC_SESSION_TOKEN_STATUS_VALID = 'VALID';
export const FACETEC_SDK_PATH = '/vendor/facetec-core-sdk-v9.6.85';
export const FACETEC_SDK_RESOURCES_PATH = `${FACETEC_SDK_PATH}/resources`;
export const FACETEC_SDK_SCRIPT_PATH = `${FACETEC_SDK_PATH}/FaceTecSDK.js`;

export const FACETEC_SDK_STATUS_NEVER_INITIALIZED = 0;

export const STEP_INTRO = 'INTRO';
export const STEP_CONSENT = 'CONSENT';
export const STEP_EDUCATION = 'EDUCATION';
export const STEP_EDUCATION_MLC = 'EDUCATION_MLC';
export const STEP_CAMERA_PERMISSION = 'CAMERA_PERMISSION';
export const STEP_FACESCAN = 'FACESCAN';
export const STEP_UNDER_REVIEW = 'UNDER_REVIEW';
export const STEP_ERROR = 'ERROR';
export const STEP_ERROR_RETRY = 'ERROR_RETRY';
export const STEP_ERROR_FACETEC_SDK_INIT_FAILURE = 'STEP_ERROR_FACETEC_SDK_INIT_FAILURE';
export const STEP_ERROR_SESSION_INFO_FAILURE = 'STEP_ERROR_SESSION_INFO_FAILURE';
export const STEP_ERROR_FACETEC_DEVICE_LOCKED_OUT = 'STEP_ERROR_FACETEC_DEVICE_LOCKED_OUT';
export const STEP_ERROR_FACETEC_DEVICE_NOT_SUPPORTED = 'STEP_ERROR_FACETEC_DEVICE_NOT_SUPPORTED';
export const STEP_ERROR_FACETEC_NETWORK_ISSUES = 'STEP_ERROR_FACETEC_NETWORK_ISSUES';
export const STEP_CANCELED = 'CANCELED';
export const STEP_UNVERIFY_INFO = 'STEP_UNVERIFY_INFO';
export const STEP_CHOOSE_VERIFICATION_METHOD = 'STEP_CHOOSE_VERIFICATION_METHOD';
export const STEP_ID_PREP = 'STEP_ID_PREP';

export const STEPS: SelfieVerificationStep[] = [
  STEP_INTRO,
  STEP_CONSENT,
  STEP_EDUCATION,
  STEP_EDUCATION_MLC,
  STEP_CAMERA_PERMISSION,
  STEP_FACESCAN,
  STEP_UNDER_REVIEW,
  STEP_ERROR,
  STEP_ERROR_RETRY,
  STEP_ERROR_FACETEC_SDK_INIT_FAILURE,
  STEP_ERROR_FACETEC_DEVICE_LOCKED_OUT,
  STEP_ERROR_FACETEC_DEVICE_NOT_SUPPORTED,
  STEP_ERROR_FACETEC_NETWORK_ISSUES,
  STEP_CANCELED,
  STEP_UNVERIFY_INFO,
  STEP_CHOOSE_VERIFICATION_METHOD,
  STEP_ID_PREP,
];

export const CONSENT_SCREEN_V1 = 0;
export const CONSENT_SCREEN_V2 = 1;
export const CONSENT_SCREEN_V3 = 2;

export const ID_VERIFICAITON_OFF = 0;
export const ID_VERIFICATION_V1 = 1;

export const ID_VERIFICATION_STATUS_VERIFIED = 'id_dob_verified';
export const ID_VERIFICATION_STATUS_UNDER_REVIEW = 'id_dob_in_review';
export const ID_VERIFICATION_STATUS_NOT_VERIFIED = 'id_dob_not_verified';

export const PHOTO_VERIFICATION_STATUS_VERIFIED = 'selfie_verified';
export const PHOTO_VERIFICATION_STATUS_UNDER_REVIEW = 'selfie_in_review';
export const PHOTO_VERIFICATION_STATUS_NOT_VERIFIED = 'selfie_not_verified';

export const ID_VERIFICATION_CONSENT_FLOW = 'ID_VERIFICATION';
export const PHOTO_AND_ID_VERIFICATION_CONSENT_FLOW = 'PHOTO_AND_ID_VERIFICATION';
export const PHOTO_VERIFICATION_CONSENT_FLOW = 'PHOTO_VERIFICATION';
